import moment from 'moment';
import {
    INNOPAY_MODE,
    MEMBER_TYPE,
    MY_VIEW_MODE,
    WEB_PLATFORM_TYPE,
    JOIN_CHAT_TYPE, MEMBER_CAREER_HISTORY_STATE,
    MISSION_TYPE,
    POPUP_TYPE,
} from "../Constants";
import Vue from 'vue'
import GlobalStore from '../GlobalStore';
import router from '../router';
import ResponseCode from "../ResponseCode";
import InnoPay from './InnoPay';
import {SPLASH_POPUP_TYPE} from "../components/modal/popup/SplashPopup";
import CommonApiCall from './CommonApiCall';
import GlobalRouter from "../GlobalRouter";
import DeviceInfoManager from "./DeviceInfoManager";

class Util {
    static eventBuffer = []
    static timerStarted = false
    static initialStrFromDay(day){
        var str = "";
        switch(day){
            case 0:
                str = "일";
                break;
            case 1:
                str = "월";
                break;
            case 2:
                str = "화";
                break;
            case 3:
                str = "수";
                break;
            case 4:
                str = "목";
                break;
            case 5:
                str = "금";
                break;
            case 6:
                str = "토";
                break;
        }
        return str
    }

    static setPhoneFormatter(el){
        var patternStr = "-";
        var patternLocationArr = [4, 9];//몇번째 칸인지 나타냄
        var keyDownLength = 0;
        //var el = document.getElementById(id);
        el.addEventListener("keydown", function(e){
            keyDownLength = e.currentTarget.value.length ;
        });

        function checkAddedAndNotMatched(text){
            for(var i = 0; i < patternLocationArr.length; i++){
                if(text.length == patternLocationArr[i] && !isNaN(text[patternLocationArr[i] - 1])){
                    return true;
                }
            }
            return false;
        }

        function checkAddedAndMatched(text){
            for(var i = 0; i < patternLocationArr.length; i++){
                if(text.length == patternLocationArr[i] - 1){
                    return true;
                }
            }
            return false;
        }

        function checkBackSpaceAndMatched(text){
            for(var i = 0; i < patternLocationArr.length; i++){
                if(text.length == patternLocationArr[i]){
                    return true;
                }
            }
            return false;
        }

        el.addEventListener("keyup", function(e){

            var target = e.currentTarget;
            var text = target.value;
            var pattern = /^(\d{1,3}|$)(-|$)(\d{1,4}|$)(-|$)(\d{1,4}|$)$/g;
            var textMaxIndex = text.length - 1
            var isBackspace = false;
            if(target.selectionStart != text.length) return true;

            if(text.length == keyDownLength - 1) isBackspace = true;

            if(!pattern.test(text)){
                if(checkAddedAndNotMatched(text)){
                    target.value = text.substr(0, textMaxIndex) + patternStr + text[textMaxIndex];
                }else {
                    target.value = text.substr(0, textMaxIndex);
                }
            }else{
                if(checkAddedAndMatched(text) && !isBackspace){
                    target.value = text + patternStr;
                }else if(isBackspace && checkBackSpaceAndMatched(target.value)){
                    target.value = target.value.substr(0, textMaxIndex);
                }
            }
        })
    }

    static setCardNumberFormmater(el){
        this.setFormmatter(el, '-', [5, 10, 15], () => {return /^(\d{1,4}|$)(-|$)(\d{1,4}|$)(-|$)(\d{1,4}|$)(-|$)(\d{1,4}|$)$/g;});
    }

    static showChannelTalk() {
        const device = Vue.$cookies.get('device');
        if(device === 'ios' || device === 'android'){
            Util.showBrowser('https://soccerhow.channel.io/home')
        }else {
            window.open('https://soccerhow.channel.io/home');
        }
    }

    static isApp(){
        const device = Vue.$cookies.get('device');
        return device === 'ios' || device === 'android';
    }

    static setCardMMYYFormmater(el){
        this.setFormmatter(el, '/', [3], () => {return /^(\d{1,2}|$)(\/|$)(\d{1,2}|$)$/g;});
    }

    static setYearDotMonthFormmater(el){
        this.setFormmatter(el, '.', [5], () => {return /^(\d{1,4}|$)(.|$)(\d{1,2}|$)$/g;});
    }

    static setYYYYMMDDFormmater(el){
        this.setFormmatter(el, '/', [5, 8], () => {return /^(\d{1,4}|$)(\/|$)(\d{1,2}|$)(\/|$)(\d{1,2}|$)$/g;});
    }

    static setFormmatter(el, patternStr, patternLocationArr, pPattern){
        var keyDownLength = 0;
        //var el = document.getElementById(id);
        el.addEventListener("keydown", function(e){
            keyDownLength = e.currentTarget.value.length ;
        });

        function checkAddedAndNotMatched(text){
            for(var i = 0; i < patternLocationArr.length; i++){
                if(text.length == patternLocationArr[i] && !isNaN(text[patternLocationArr[i] - 1])){
                    return true;
                }
            }
            return false;
        }

        function checkAddedAndMatched(text){
            for(var i = 0; i < patternLocationArr.length; i++){
                if(text.length == patternLocationArr[i] - 1){
                    return true;
                }
            }
            return false;
        }

        function checkBackSpaceAndMatched(text){
            for(var i = 0; i < patternLocationArr.length; i++){
                if(text.length == patternLocationArr[i]){
                    return true;
                }
            }
            return false;
        }

        el.addEventListener("keyup", function(e){
            var target = e.currentTarget;
            var text = target.value;
            var pattern = pPattern();
            var textMaxIndex = text.length - 1
            var isBackspace = false;
            if(target.selectionStart != text.length) return true;

            if(text.length == keyDownLength - 1) isBackspace = true;

            if(!pattern.test(text)){
                if(checkAddedAndNotMatched(text)){
                    target.value = text.substr(0, textMaxIndex) + patternStr + text[textMaxIndex];
                }else {
                    target.value = text.substr(0, textMaxIndex);
                }
            }else{
                if(checkAddedAndMatched(text) && !isBackspace){
                    target.value = text + patternStr;
                }else if(isBackspace && checkBackSpaceAndMatched(target.value)){
                    target.value = target.value.substr(0, textMaxIndex);
                }
            }
        })
    }

    static setDateToMD(dateStr){
        if(!dateStr) return '';
        const month = parseInt(dateStr.substr(5, 2));
        const date = parseInt(dateStr.substr(8, 2));

        return month + '/' + date;
    }

    static copyToClipboard(copyStr){
        window.copyToClipboard(copyStr);
    }

    static once = (fn) => {
        let done = false;
        return async (...args) => {
            if (!done) {
                done = true;
                await fn(...args);
                done = false;
            }
        }
    }

    static getYYYYDotMMDotDDDayStr(dateStr){
        var momentInstance = moment(dateStr, "YYYY-MM-DD");
        var showDateStr = momentInstance.format('YYYY.MM.DD');
        showDateStr += "(" + this.initialStrFromDay(momentInstance.day()) + ")";
        return showDateStr
    }

    static getMMSlashDDDayStr(dateStr){
        var momentInstance = moment(dateStr, "YYYY-MM-DD");
        var showDateStr = momentInstance.format('MM/DD');
        showDateStr += " (" + this.initialStrFromDay(momentInstance.day()) + ")";
        return showDateStr
    }

    //2024년 10월 11일 금요일
    static getMMDDDayHangulStr(dateStr){
        var momentInstance = moment(dateStr, "YYYY-MM-DD");
        var showDateStr = momentInstance.format('YYYY년 MM월 DD일');
        showDateStr += ' ' + this.initialStrFromDay(momentInstance.day()) + "요일";
        return showDateStr
    }

    static getMMDDDayHangulStrExceptionYYYY(dateStr) {
        var momentInstance = moment(dateStr, "YYYY-MM-DD");
        var showDateStr = momentInstance.format('MM월 DD일');  // 년도를 제외한 월, 일 형식
        showDateStr += ' ' + this.initialStrFromDay(momentInstance.day()) + "요일";  // 요일 추가
        return showDateStr;
    }

    //9월 16일
    static getMDDHangulStr(dateStr){
        var momentInstance = moment(dateStr, "YYYY-MM-DD HH:mm:ss");
        var showDateStr = momentInstance.format('M월 DD일');
        return showDateStr
    }

    static getMMHangulStr(dateStr){
        return moment(dateStr, "YYYY-MM").format('YYYY년 MM월');
    }

    static getYYYMMDDHangulStr(dateStr){
        if(!dateStr) return '';
        return moment(dateStr, "YYYY-MM-DD").format('YYYY년 MM월 DD일');
    }

    static getMMDDDayBracketStr(dateStr){
        var momentInstance = moment(dateStr, "YYYY-MM-DD");
        var showDateStr = momentInstance.format('YYYY년 MM월 DD일');
        showDateStr += ' (' + this.initialStrFromDay(momentInstance.day()) + ")";
        return showDateStr
    }

    //오후 6:00 ~ 7:30
    static getAmPmTimeStr(begin_time, end_time){
        const begin_time_int = begin_time.substr(0, 2);
        const end_time_int = end_time.substr(0, 2);

        let begin_time_str = begin_time;
        let end_time_str = end_time;

        let is_afternoon = false;

        if(begin_time_int > 12) {
            is_afternoon = true;
            begin_time_str = (begin_time_int - 12) + begin_time.substr(2, 3);
        }
        if(end_time_int > 12) end_time_str = (end_time_int - 12) + end_time.substr(2, 3);

        return (is_afternoon ? '오후' : '오전') + ' ' + begin_time_str + ' ~ ' + end_time_str;
    }

    //2024년 4월 3일 수요일 18:02
    static getMMDDDayHHmmBracketStr(dateStr){
        var momentInstance = moment(dateStr, "YYYY-MM-DD HH:mm:ss");
        var showDateStr = momentInstance.format('YYYY년 M월 D일');
        showDateStr += ' (' + this.initialStrFromDay(momentInstance.day()) + ")";
        showDateStr += momentInstance.format('HH:mm');
        return showDateStr
    }

    static getMMDDDayHHmm(dateStr){
        var momentInstance = moment(dateStr, "YYYY-MM-DD HH:mm:ss");
        var showDateStr = momentInstance.format('YYYY년 M월 D일');
        showDateStr += ' ' + momentInstance.format('HH:mm');
        return showDateStr
    }

    static async checkDirectMessage(){
        const res = await CommonApiCall.get('/api/soccerhow/mine/no_direct_message')
        const today = moment().format('YYYY-MM-DD')
        const hideDate = localStorage.getItem('CLOSE_REQUEST_POPUP_ONE_DAY')
        if (res.data.soccerhows.length > 0 && today !== hideDate) {
            GlobalStore.setIsShowDirectRequestPopup(true, res.data.soccerhows[0])
        }
    }

    static checkIsCoach() {
        const savedDay = localStorage.getItem('IS_SHOW_TRANS_COACH_POPUP')
        const diffDays = savedDay
                        ? moment().diff(moment(savedDay, 'YYYY-MM-DD'), 'days')
                        : 0;
        const isPassOnedays = !savedDay || diffDays >= 1
        const is_coach = GlobalStore.loginInfo().is_coach
        const is_temp_coach = GlobalStore.loginInfo().is_temp_coach
        if (is_coach == 0 && is_temp_coach == 1 && isPassOnedays) {
            GlobalStore.setTransCoachPopup(true)
        }
    }

    static async checkIsWriteRequestForm() {
        const res = await CommonApiCall.get('/api/soccerhow/check/join/written');
        const savedDay = localStorage.getItem('IS_SHOW_REQUEST_POPUP_FORCE'); // (오타도 있음)

        const diffDays = savedDay
                        ? moment().diff(moment(savedDay, 'YYYY-MM-DD'), 'days')
                        : 0;
        const isPassThreeDays = !savedDay || diffDays >= 3;

        if (isPassThreeDays && !res.data.isSoccerHowJoinWritten && GlobalStore.loginInfo().is_temp_coach == MEMBER_TYPE.USER) {
            GlobalStore.setIsShowRequestPopupForce(true);
        }
        return res.data.isSoccerHowJoinWritten
    }   

    static getTimeGapStr(begin_date_time, end_date_time){
        const startMoment = moment(begin_date_time, "YYYY-MM-DD HH:mm:ss");
        const endMoment = moment(end_date_time, "YYYY-MM-DD HH:mm:ss");
        const diff_minutes = endMoment.diff(startMoment,'minutes');
        const minutes = diff_minutes % 60;
        const hour = parseInt(diff_minutes / 60);
        const str = (hour > 0 ? hour + '시간 ' : '') + (minutes > 0 ? minutes + '분' : '');
        return str;
    }

    static getWebPlatForm(){
        if( /Android/i.test(navigator.userAgent)) {
            return WEB_PLATFORM_TYPE.ANDROID;
        } else if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
            return WEB_PLATFORM_TYPE.IOS;
        } else {
            return WEB_PLATFORM_TYPE.OTHER;
        }
    }

    static getStrForVideoPreview(){
        const platform = this.getWebPlatForm();
        return platform === WEB_PLATFORM_TYPE.IOS ? '' : '#t=0.001';
    }

    static showBrowser(url){
        url = url.replace('/?', '?');
        const device = Vue.$cookies.get('device');
        if(device === 'android'){
            window.Android.showBrowser(url);
        }else if(device === 'ios'){
            /*eslint-disable no-undef */
            webkit.messageHandlers.ios.postMessage({cmd : 'showBrowser', url : url});
        }
    }

    static checkName(name){
        return (/^[가-힣]+$/gi).test(name);
    }

    static checkNickName(nickName){
        return (/^[가-힣|0-9|a-z]+$/gi).test(nickName);
    }

    static showProfile(writerIdx, writerType, transitionName = '', is_coach = '0'){
        //이전 tb_coach를 이용해서 사용하는 프로필은 안보이게 조치
        if (writerType == MEMBER_TYPE.COACH) {
            return
        }
        Util.sendEventClick('프로필_조회')
        console.log('showProifile');

        if(is_coach == '1'){
            const data = {mode : MY_VIEW_MODE.OTHER, memberIdx : writerIdx, isModalBackTransparent: true, isPopup: true};
            if(GlobalStore.loginInfo() && GlobalStore.loginInfo().idx == writerIdx) {
                // data.mode = MY_VIEW_MODE.ME;
                // data.isForceModal = true;
                GlobalStore.closeModalAll();
                GlobalRouter.push('/view/my?ver=' + new Date().getTime());
                return;
            }
            if(transitionName) data.transitionName = transitionName;
            GlobalStore.addModal('ProfileMain', data);
        }else {
            const data = {mode: MY_VIEW_MODE.OTHER, memberIdx: writerIdx, isModalBackTransparent: true, isPopup: true};
            if(GlobalStore.loginInfo() && GlobalStore.loginInfo().idx == writerIdx) {
                // data.mode = MY_VIEW_MODE.ME;
                // data.isForceModal = true;
                GlobalStore.closeModalAll();
                GlobalRouter.push('/view/my?ver=' + new Date().getTime());
                return;
            }
            if (transitionName) data.transitionName = transitionName;
            GlobalStore.addModal('ProfileMain', data);
        }
        this.checkAppLinkPageShow();
    }

    static checkLoginAndWeb() {
        const device = Vue.$cookies.get('device');
        // const userAgent = navigator.userAgent;
        const condition =
                        // (userAgent.match(/iPhone|iPad|iPod/i) || userAgent.match(/android/i)) &&
                        (device !== 'android' && device !== 'ios') &&
                        !GlobalStore.isLogin()
        if (condition) {
            GlobalStore.addModal('SignupPopupModal', { transitionName: '', isModalBackTransparent: true })
            return false
        } else {
            return true
        }
    }

    static checkAppLinkPageShow(action, param0 = null, param1 = null, param2 = null){
        const device = Vue.$cookies.get('device');
        const userAgent = navigator.userAgent;
        const condition =
            process.env.NODE_ENV === 'production' &&
                        (userAgent.match(/iPhone|iPad|iPod/i) || userAgent.match(/android/i)) && 
                        (device !== 'android' && device !== 'ios') && 
                        !Vue.prototype.$hasOwnProperty(sessionStorage, 'IS_SHOW_NOW_DETAIL_APPLINK_POP')
        if (condition) {
            GlobalStore.setSchemes(action, param0, param1, param2);
            GlobalStore.setIsShowAppLinkToast(true)
            return true;
        } else {
            // GlobalStore.setIsShowAppLinkToast(true)
            return false;
        }
    }

    static async renewFriends(){
        const device = Vue.$cookies.get('device');
        if(!(device === 'ios' || device === 'android')) {
            return;
        }

        const local_storage_key = 'IS_CONTACT_CHECKED';
        const today = moment().format('YYYY-MM-DD');

        if (process.env.VUE_APP_IS_TEST_SERVER !== undefined) {
            // url = 'https://obyungear-user-test.ubiplus.co.kr';
        } else {
            if(Vue.prototype.$hasOwnProperty(localStorage, local_storage_key) && localStorage.getItem(local_storage_key) === today){
                // console.log('갱신끝')
                return;
            }
        }

        const contacts_str = await DeviceInfoManager.getContacts();
        if(contacts_str === ''){ //권한
            return;
        }

        const contacts = JSON.parse(contacts_str);

        // DeviceInfoManager;
        // const contacts = [{name : 'test', number : '010-0000-0902'}];

        const refomatted_contacts = contacts.map((each) => {
            const removed_82_number = each.number.substr(0, 2) === '82' ? '0' + each.number.substr(2, 100) : each.number;
            return removed_82_number.replaceAll('-', '').replaceAll('+82', '0');
        }).filter((each) => {
            return each.indexOf('010') === 0;
        }).map((each) => {
            return each.substr(0, 3) + '-' + each.substr(3,4) + '-' + each.substr(7, 4);
        });

        // alert(JSON.stringify(refomatted_contacts));

        const parameters = {};
        parameters.contacts = refomatted_contacts;

        const res = await CommonApiCall.post('/api/member/friend/renew', parameters);
        if(res.data.code === ResponseCode.SUCCESS){
            localStorage.setItem(local_storage_key, today);
        }else if(res.data.code === ResponseCode.FAIL){
            GlobalStore.showAlert(res.data.msg);
        }
    }

    static async showChatWithAdmin(){
        const device = Vue.$cookies.get('device');
        if(!(device === 'ios' || device === 'android') && !(Vue.$cookies.get('nologin_id'))) {
            GlobalStore.showAlert('비회원 아이디가 존재하지 않습니다.');
            return;
        }
        const member_type = MEMBER_TYPE.USER;
        let member_idx = this.getAdminMemberIdx();
        await CommonApiCall.showPersonalChat(member_idx, member_type, JOIN_CHAT_TYPE.SINGLE);
    }

    static getJoinThumbnailEmpty(max_cnt, insert_date){
        const days_diff = moment(insert_date, 'YYYY-MM-DD HH:mm:ss').diff(moment(), 'days');

        let thumnail = null;
        if(max_cnt <= 5 || days_diff <= 2){
            thumnail = require('@/assets/join_thumbnail_empty01.png');
        } else if(max_cnt > 5 && max_cnt <= 12){
            thumnail = require('@/assets/join_thumbnail_empty02.png');
        } else if(max_cnt > 12 && max_cnt <= 20){
            thumnail = require('@/assets/join_thumbnail_empty03.png');
        } else {
            thumnail = require('@/assets/join_thumbnail_empty04.png');
        }
        return thumnail;
    }

    static sendEventClick(key, isSaveDB){
        if (isSaveDB) {
            Util.saveEventDB(key)
        } else {
            window.gtag('event', key);
        }
    }

    static saveEventDB(type) {
        Util.eventBuffer.push({
            type: type
        })

        if (!Util.timerStarted) {
            Util.timerStarted = true
            const saveEventList = async () => {
                let eventBuffer = Util.eventBuffer
                Util.eventBuffer = []
                const res = await CommonApiCall.post('/api/save/app_event', { event_list: eventBuffer })

                if (res.data.code === 0) {
                    eventBuffer = []
                }
            }
            setInterval(() => {
                if (Util.eventBuffer.length > 0) {
                    saveEventList()
                }
            }, 15000);
        }
    }

    // special_skill = 개인기
    // playstyle = 플레이 스타일
    // use_reasons = 관심사
    // visit_reasons = 이용 목적
    static isCompleteProfileBox(memberInfo, isCoach = false) {
        let checkList;
        if (isCoach) {
            checkList = ['position', 'age_range', 'height', 'foot_way', 'special_skill', 'playstyle', 'place_name', 'use_reasons', 'visit_reasons', 'career']
        } else {
            checkList = ['place_name', 'position', 'use_reasons', 'age_range']
        }
        let isComplete;
        for (const key of checkList) {
            if (memberInfo[key] === null) {
                isComplete = false
                return isComplete
            }
        }
        isComplete = true

        return isComplete
    }

    static checkDefaultMemberInfoComplete() {
        const loginInfo = GlobalStore.loginInfo();
        if(!loginInfo) return [true, ''];
        let isCoach = (loginInfo && loginInfo.is_temp_coach == 1) ? true : false
        let msg = '';

        if(GlobalStore.isAdmin()) return [true, msg];

        const memberCondition = !loginInfo.phone || !loginInfo.name || !loginInfo.birthday || !loginInfo.sex || !loginInfo.place_id || !loginInfo.visit_reason || !loginInfo.career
        const coachCondition = !loginInfo.phone || !loginInfo.name || !loginInfo.birthday || !loginInfo.sex || !loginInfo.place_id || !loginInfo.coach_type
        let condition = isCoach ? coachCondition : memberCondition

        if (loginInfo) {
            if (condition) {
                return [false, msg];
            }
            return [true, msg];
        } else {
            return [false, msg]
        }

    }

    static checkIsProfileComplete(){
        const loginInfo = GlobalStore.loginInfo();

        let msg = '';

        if(GlobalStore.isAdmin()) return [true, msg];

        if(
            // !loginInfo.nic_name
            // || !loginInfo.introduce
            !loginInfo.foot_way
            // || !loginInfo.age_range
            || !loginInfo.height
            // || !loginInfo.position
            // || !loginInfo.place_name
        //     || !loginInfo.special_skill || !loginInfo.playstyle || !loginInfo.interests || !loginInfo.use_reasons
            // || !loginInfo.region_name || !loginInfo.place_id
        ){
            // if(!(loginInfo.nic_name)) msg = '닉네임을 입력해주세요.';
            // else if(!loginInfo.introduce) msg = '자기소개를 입력해주세요.';
            // else if(!loginInfo.age_range) msg = '나이대를 선택해주세요.';
            if(!loginInfo.foot_way) msg = ' 자주사용하는발을 선택해주세요.';
            else if(!loginInfo.height) msg = '키를 입력해주세요.';
            // else if(!loginInfo.position) msg = '포지션찾기를 진행해주세요.';
            // else if(!loginInfo.special_skill) msg = '주특기를 선택해주세요.';
            // else if(!loginInfo.playstyle) msg = '플레이스타일을 선택해주세요.';
            // else if(!loginInfo.interests) msg = '축구관심분야를 선택해주세요.';
            // else if(!loginInfo.use_reasons) msg = '이용목적을 선택해주세요.';
            // else if(!loginInfo.region_name) msg = '거주지를 선택해주세요.';
            // else if(!loginInfo.place_name) msg = '활동지역을 입력해주세요.';

            return [false, msg];
        }
        return [true, msg];
    }

    static checkLogin () {
        if (!GlobalStore.isLogin()) {
            // GlobalStore.addModal('MemberTypeSelect', {
            //     isExistLoginBtn: true, isShowCloseBtn: false, completeAction: (register_type) => {
            //         GlobalStore.addModal('RegistTypeSelect', { isModalBackTransparent: true, transitionName: 'bottom', register_type: register_type });
            //         this.$GlobalStore.addModal('MemberRegist', { isModalBackTransparent: true, transitionName: 'bottom', register_type: register_type });
            //     }
            // })


            GlobalStore.addModal('LoginIntro', {transitionName: 'right'});
            return false
        } else {
            return true
        }
    }

    static checkProfileCompleteOrShowRequiredProfile(){
        const is_complete = true;
        return is_complete;
    }

    static async checkAfterLogin(isSoccerhowWritten, loginInfo, is_opentalk_written){
        //포지션 웹에서 넘어올때 사용하는부분.
        // if(Vue.prototype.$hasOwnProperty(window, 'is_from_position_web') && window.is_from_position_web === true){
        //     const position_web_res = await await CommonApiCall.get('/api/position_web/target');
        //
        //     if(position_web_res.data.target){
        //         const target = position_web_res.data.target;
        //
        //         // sessionStorage.removeItem('IS_FROM_POSITION_WEB');
        //         window.is_from_position_web = false;
        //
        //         if(process.env.NODE_ENV === 'development'){
        //             // location.href = 'https://www.naver.com';
        //             location.href = 'http://192.168.0.203:8081/view/find_position?target=' + target;
        //         } else {
        //             location.href = 'https://positionfinder.kr/view/find_position?target=' + target;
        //         }
        //         return;
        //     }
        // }

        const isLanding = JSON.parse(sessionStorage.getItem('IS_LANDING'))

        if (isLanding) {
            router.push({ path: '/view/home' + '?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
            GlobalStore.addModal('FindPositionProMain');
            sessionStorage.removeItem('IS_LANDING')
            
        }

        GlobalStore.closeSpliceModal('MemberTypeSelect');

        GlobalStore.setSoccerhowWrite(isSoccerhowWritten)
        GlobalStore.setIsOpenChatWrite(is_opentalk_written)

        const [is_default_complete] = this.checkDefaultMemberInfoComplete();

        if (!is_default_complete) {
            GlobalStore.showRequiredMemberInfoSetting(0);
        }

        if (GlobalStore.loginInfo() && GlobalStore.loginInfo().inactive === '1') {
            GlobalStore.addModal('AccountDisabled')
        }

        if (!GlobalStore.loginInfo().place_name) {
            GlobalStore.addModal('SettingPlacePopup', {transitionName: 'bottom', isModalBackTransparent: true})
        }


        let is_production = false;_
        if (process.env.NODE_ENV === 'production') {
            is_production = true;
        }

        if(GlobalStore.loginInfo() && GlobalStore.loginInfo().is_temp_coach == '0'){
            const refreshPopup = async () => {
                //api 호출해서 새로운게 왔으면 보임.
                if(!GlobalStore.checkViewExist('SplashPopup')){
                    const res = await CommonApiCall.get('/api/direct_message/taken/new');
                    if(res.data.direct_messages.length > 0){
                        GlobalStore.addModal('SplashPopup', {transitionName : '', isModalBackTransparent : true, popup_type : SPLASH_POPUP_TYPE.DIRECT_MESSAGE, popup_data : res.data.direct_messages[0]})
                    }
                }
            }

            const checkDirectMessagePopup = async () => {
                const res = await CommonApiCall.get('/api/direct_message/taken/reject');

                if (res.data.direct_message) {
                    GlobalStore.addModal('DirectMessagePopupModal', {
                        transitionName: '', 
                        isModalBackTransparent: true, 
                        popupType: POPUP_TYPE.REJECT, 
                        direct_message: res.data.direct_message
                    })
                }
            }

            refreshPopup();
            checkDirectMessagePopup()
            if (is_production) {
                setInterval(() => {
                    refreshPopup();
                    checkDirectMessagePopup()
                }, 10000);
            }
        }

        if(GlobalStore.isLogin()){
            const checkChatOpened = async () => {
                if(!GlobalStore.checkViewExist('ChatOpenPopup')){
                    const res = await CommonApiCall.get('/api/chat/coach_chat/opened');
                    if(res.data.chat_member){
                        // GlobalStore.addModal('ChatOpenPopup', {
                        //     transitionName : 'bottom', isModalBackTransparent : true,
                        //     chat_idx : res.data.chat_member.chat_idx, left_member : res.data.my_member, right_member : res.data.opponent_member})
                        GlobalStore.addModal('DirectMessagePopupModal', {
                            transitionName: '', 
                            isModalBackTransparent: true, 
                            popupType: POPUP_TYPE.CHAT_OPEN, 
                            left_member: res.data.my_member,
                            right_member: res.data.opponent_member,
                            chat_idx: res.data.chat_member.chat_idx
                        })
                    }

                    if(res.data.member_career_history){
                        if(res.data.member_career_history.state == MEMBER_CAREER_HISTORY_STATE.APPROVED){
                            GlobalStore.setIsShowModifyPopup(true, MEMBER_CAREER_HISTORY_STATE.APPROVED, '', res.data.member_career_history.idx)
                        }else if(res.data.member_career_history.state == MEMBER_CAREER_HISTORY_STATE.REJECT){
                            GlobalStore.setIsShowModifyPopup(true, MEMBER_CAREER_HISTORY_STATE.REJECT, res.data.member_career_history.reject_reason, res.data.member_career_history.idx)
                        }
                    }

                    if(res.data.position_pro_history){
                        GlobalStore.addModal('CompleteMissonPopup', { isModalBackTransparent: true, transitionName: '', mission_type: MISSION_TYPE.INVITE_FRIENDS, position_pro_history_idx: res.data.position_pro_history.position_pro_idx })
                    }

                    if(res.data.banner){
                        let is_show_banner = true;
                        const TRAINING_BANNER_POPUP_IDXES = 'TRAINING_BANNER_POPUP_IDXES';
                        if(Vue.prototype.$hasOwnProperty(localStorage, TRAINING_BANNER_POPUP_IDXES)){
                            const training_banner_popup_idxes = JSON.parse(localStorage.getItem(TRAINING_BANNER_POPUP_IDXES));
                            if(Vue.prototype.$hasOwnProperty(training_banner_popup_idxes, res.data.banner.idx)){
                                is_show_banner = false;
                            }
                        }
                        if (GlobalStore.loginInfo().is_temp_coach == 0) {
                            if(is_show_banner && !GlobalStore.checkViewExist('NewTrainingVideoPopup')){
                                GlobalStore.addModal('NewTrainingVideoPopup', { isModalBackTransparent: true, transitionName: '', banner : res.data.banner})
                            }
                        }
                    }

                    if (res.data.member_popups.length > 0) {
                        this.showMemberPopup(res.data.member_popups);
                    }

                }
            }

            //어플 접속 포인트 부분도 추가되어있음.
            const saveActiveDate = async () => {
                await CommonApiCall.post('/api/member/update/active_date')
            }

            saveActiveDate()
            checkChatOpened();
            if (is_production) {
                setInterval(() => {
                    checkChatOpened();
                }, 10000);
                setInterval(() => {
                    saveActiveDate();
                }, 60000)
            }
        }

        if(GlobalStore.isLogin()){
            const checkReviewConfirmed = async () => {
                if(!GlobalStore.checkViewExist('SplashPopup')){
                    const res = await CommonApiCall.get('/api/join/schedule/review/check');
                    if(res.data.join_schedules.length > 0){
                        GlobalStore.addModal('SplashPopup', {transitionName : '', isModalBackTransparent : true, popup_type : SPLASH_POPUP_TYPE.REVIEW_CONFIRM, popup_data : res.data.join_schedules[0]})
                    }
                }
            }

            checkReviewConfirmed();
            if (is_production) {
                setInterval(() => {
                    checkReviewConfirmed();
                }, 10000);
            }
        }

        setTimeout(async () => {
            await this.renewFriends();
        }, 3000)

    }

    static showMemberPopup(member_popups) {
        const memberPopups = member_popups;
        memberPopups.forEach(each => {
            each.popup_type = parseInt(each.popup_type)
        })
        memberPopups.forEach(member_popup => {
            GlobalStore.addModal('MemberPopupList', {
                member_popup_idx: member_popup.idx,
                transitionName: '',
                isModalBackTransparent: true,
                type: member_popup.popup_type
            })
        })
    }

    static setInputComma(e, callback){
        const target = e.currentTarget;
        const rgx1 = /[^\d]/g;
        const rgx2 = /(\d+)(\d{3})/;
        let num = target.value.replace(rgx1,"");

        while (rgx2.test(num)) num = num.replace(rgx2, '$1' + ',' + '$2');

        if(callback) callback(num);
    }


    static async payIntegrated(pay_method, parameters, callback_first, callback_second, callback_before_save = async () => [true, {}]){
        if(parameters.pay_mode === INNOPAY_MODE.DIRECT_PAY){
            const first_parameters = window.copyObject(parameters);
            first_parameters.try = 1;
            const res = await callback_first(first_parameters);
            if(res.data.code !== ResponseCode.SUCCESS){
                GlobalStore.showAlert(res.data.msg);
                GlobalStore.hideProgress();
                return;
            }
            const moid = res.data.order_info.moid;
            const price = res.data.order_info.amt;
            const goods_name = res.data.order_info.goodsName;
            const phone = res.data.order_info.phone;
            const memberName = res.data.order_info.buyerName;
            const email = res.data.order_info.email ? res.data.order_info.email : 'email@example.com';

            //결제 정보 채워서 결제 요청
            const second_parameters = window.copyObject(parameters);
            second_parameters.try = 2;
            InnoPay.goPayIntergrated(pay_method, goods_name, price, memberName, phone, email, moid, "Y", {}, "",
                async (dataStr) => {
                    const [is_success, callback_before_save_result] = await callback_before_save();
                    if(!is_success) return;
                    Object.assign(second_parameters, callback_before_save_result);

                    second_parameters.result = dataStr;
                    callback_second(second_parameters)
                });

        }else if(parameters.pay_mode === INNOPAY_MODE.REGISTERED_CARD_PAY){
            const [is_success, callback_before_save_result] = await callback_before_save();
            if(!is_success) return;
            Object.assign(parameters, callback_before_save_result);

            await callback_second(parameters);
        }

    }

    static getExistUrl(contents) {
        const urlPattern = /(https?:\/\/[^\s]+)/g;
        let urls = contents.match(urlPattern) ? contents.match(urlPattern)[0] : null
        let result = contents.replace(urlPattern, '')
        result = result.replace(/[\r\n]+/g, ' ').trim();
        return {'result': result, 'url': urls}
    }

    static removeLink(contents) {
        if(!contents) return contents;
        const urlPattern = /(https?:\/\/[^\s]+)/g;
        let result = contents.replace(urlPattern, '')
        result = result.replace(/[\r\n]+/g, ' ').trim();
        return result
    }

    static removeYoutubeLink(contents){
        if(!contents) return contents;
        return contents.replace(/https?:\/\/youtu.be\/(\S+)\r?\n?|https?:\/\/(?:www\.)?youtube.com\/shorts\/(\S+)\r?\n?|https?:\/\/(?:www\.)?youtube.com\/watch\?v=(\S+)\r?\n?/is, '');
    }

    static checkYoutubeLink(str){
        const pattern = /https?:\/\/youtu.be\/(\S+)\r?\n?|https?:\/\/(?:www\.)?youtube.com\/shorts\/(\S+)\r?\n?|https?:\/\/(?:www\.)?youtube.com\/watch\?v=(\S+)\r?\n?/is;
        return pattern.test(str);
    }

    static getYoutubeLinkArr(str){
        const pattern = /https?:\/\/youtu.be\/(\S+)\r?\n?|https?:\/\/(?:www\.)?youtube.com\/shorts\/(\S+)\r?\n?|https?:\/\/(?:www\.)?youtube.com\/watch\?v=(\S+)\r?\n?/is;
        return str.match(pattern);
    }

    static getYoutubeThumbnail(contents){
        const pattern = /https?:\/\/youtu.be\/(\S+)\r?\n?|https?:\/\/(?:www\.)?youtube.com\/shorts\/(\S+)\r?\n?|https?:\/\/(?:www\.)?youtube.com\/watch\?v=(\S+)\r?\n?/is;
        const youtubeArr = pattern.exec(contents) ?? [];
        let firstYoutube = "";

        if(youtubeArr[1]){
            const key_arr = youtubeArr[1].split('?');
            firstYoutube = 'https://img.youtube.com/vi/' + key_arr[0] + '/0.jpg';
        }else if(youtubeArr[2]){
            const key_arr = youtubeArr[2].split('?');
            firstYoutube = 'https://i.ytimg.com/vi/' + key_arr[0] + '/sd2.jpg';
        }else if(youtubeArr[3]){
            const key_arr = youtubeArr[3].split('&');
            firstYoutube = 'https://img.youtube.com/vi/' + key_arr[0] + '/0.jpg';
        }

        return firstYoutube;
    }

    static checkIsLatestVersion(){
        const app_version = Vue.$cookies.get('appv');
        const device = Vue.$cookies.get('device');

        let is_latest_version = true;

        if(!app_version) return is_latest_version;

        if(device === 'android'){
            is_latest_version = parseInt(app_version) >= 12;
        }else if(device === 'ios'){
            is_latest_version = parseInt(app_version) >= 17;
        }

        return is_latest_version
    }

    static isShowDefaultSettings(isCloseModal = true) {
        const [is_default_complete] = this.checkDefaultMemberInfoComplete();
            
        if (!is_default_complete) {
            if (isCloseModal) {
                GlobalStore.closeLastModal();
            }
            if (!GlobalStore.isLogin()) {
                GlobalStore.addModal('MemberTypeSelect', {
                    isExistLoginBtn: true, isShowCloseBtn: false, completeAction: (register_type) => {
                        this.$GlobalStore.addModal('RegistTypeSelect', { isModalBackTransparent: true, transitionName: 'bottom', register_type: register_type });
                        // this.$GlobalStore.addModal('MemberRegist', { isModalBackTransparent: true, transitionName: 'bottom', register_type: register_type });
                    }
                })
            } else {
                GlobalStore.addModal('WelcomeBack', {isWriteDefaultInfo: false, isFirst: false});
            }
            return true
        }
        return false
    }

    static showRejectSchedulePopup() {
        const html = `<div style="color: #210F03; padding: 20px 0px 20px 0px; border-bottom:1px solid #EBEBEB; font-weight:bold; line-height: 20px; font-size:16px;">스케줄 초대 불가</div><div style="padding:0px 15px;"><br>스케줄 활동을 하지 않아<br>스케줄에 초대할 수 없는 회원입니다.</div>`;
        GlobalStore.showConfirm(html, () => { }, null, '확인', GlobalStore.CONFIRM_TYPE.VERSION4, false, () => { });
    }

    static showRejectProfilePopup() {
        const html = `<div style="color: #210F03; padding: 20px 0px 20px 0px; border-bottom:1px solid #EBEBEB; font-weight:bold; line-height: 20px; font-size:16px;">프로필 비공개</div><div style="padding:0px 15px;"><br>프로필을 비공개 한 회원입니다.</div>`;
        GlobalStore.showConfirm(html, () => { }, null, '확인', GlobalStore.CONFIRM_TYPE.VERSION4, false, () => { GlobalStore.closeLastModal() });
    }

    static transPosition = function(position) {
        if(position === null || position === undefined)
            return null;

        const data = {
            'CF':"CF",
            'LW':"WF",
            'RW':"WF",
            'WF':"WF",
            'LWF': "WF",
            'RWF': "WF",
            'MF':"CM",
            'SS':"SS",
            'AM':"AM",
            'CM':"CM",
            'LM':"WM",
            'RM':"WM",
            'WM':"WM",
            'DM':"DM",
            'LWB':"WB",
            'RWB':"WB",
            'WB': "WB",
            'LB':"FB",
            'RB':"FB",
            'FB':"FB",
            'CB':"CB",
            'FW':"CF",
            'GK': 'GK'
        };
        if(position in data) {
            return data[position];
        }
        return null;
    }

    static position_display_str = function(member_type, position, is_coach){
        if(is_coach && is_coach == '1' || member_type == MEMBER_TYPE.COACH){
            return '코치';
        }
        return position;
    }

    static getMddhhTimeStr(begin_date_time, end_date_time){
        const begin_date_moment = moment(begin_date_time, "YYYY-MM-DD HH:mm:ss");
        const end_date_moment = moment(end_date_time, "YYYY-MM-DD HH:mm:ss");
        const str = parseInt(begin_date_moment.format('MM')) + '월 ' + begin_date_moment.format('DD') + '일 ' + begin_date_moment.format('HH:00') + ' ~ ' + end_date_moment.format('HH:00');
        return str;
    }

    static isAdmin(member_idx){
        let admin_member_idx = null;
        if(process.env.NODE_ENV === 'development'){
            admin_member_idx = '349362';
        }else if(process.env.NODE_ENV === 'production'){
            admin_member_idx = '423159';
        }

        return member_idx == admin_member_idx
    }

    static getAdminMemberIdx(){
        let member_idx = null;
        if(process.env.NODE_ENV === 'development'){
            member_idx = '349362';
        }else {
            member_idx = '423159';
        }
        return member_idx;
    }

    static async showDirectMessageSenderForm(modal_data){
        const parameters = {};
        parameters.target_member_idx = modal_data.memberInfo.idx ? modal_data.memberInfo.idx : modal_data.memberInfo.member_idx;
        const res = await CommonApiCall.get('/api/chat/check/coach_chat/exist', {params : parameters});
        if(res.data.code === ResponseCode.SUCCESS){
            if(res.data.chat_idx){
                await CommonApiCall.showChattingBySoccerJoinIdx(res.data.chat_idx)
            }else {
                GlobalStore.addModal('SendIndividualMessage', modal_data);
            }
        }else if(res.data.code === ResponseCode.FAIL){
            GlobalStore.showAlert(res.data.msg);
        }
    }

    /**
     * duration milliseconds 1000 = 1초
     * */
    static vibrate(){
        const app_version = Vue.$cookies.get('appv');
        const device = Vue.$cookies.get('device');

        let is_apply = process.env.NODE_ENV === 'development';

        if (app_version) {
            if (device === 'ios') {
                is_apply = parseInt(app_version) >= 39;
            } else if (device === 'android') {
                is_apply = parseInt(app_version) >= 36;
            }
        }

        if(!is_apply) return;

        if(device === 'android'){
            const duration = 100;
            window.Android.vibrate(duration);
        }else if(device === 'ios'){
            /*eslint-disable no-undef */
            webkit.messageHandlers.ios.postMessage({ cmd: 'vibrate', haptick_style : 'heavy'});
        }
    }

}
var Mercenary = (function(){
    let _obj = {};

    _obj.positionToString = function(position) {
        if(position === null || position === undefined)
            return "설정하지 않음";
        position.toUpperCase();
        const data = {
            'CF':"중앙 공격수",
            'LW':"윙어",
            'RW':"윙어",
            'WF':"윙어",
            'LWF': "윙어",
            'RWF': "윙어",
            'MF':"미드필드",
            'SS':"세컨트 스트라이커",
            'AM':"공격형 미드필더",
            'CM':"중앙 미드필더",
            'LM':"측면 미드필더",
            'RM':"측면 미드필더",
            'WM':"측면 미드필더",
            'DM':"수비형 미드필더",
            'LWB':"윙백",
            'RWB':"윙백",
            'WB': "윙백",
            'LB':"풀백",
            'RB':"풀백",
            'FB':"풀백",
            'CB':"센터백",
            'FW':"포워드",
            'GK': '골키퍼'
        };

        if(position in data) {
            return data[position];
        }
        return '설정하지 않음';
    }

    return _obj;
})();


//naverMap상에 표시할 마커html를 생성하는 유틸 클래스
//css는 assets/global.css 로 분리 함.
var MercenaryMarker = (function(){
    var _obj = {};

    _obj.test = function(item) {
        const mainImage = require('@/assets/img/team_training_marker.png')
        const onMainImage = require('@/assets/img/team_training_marker_on.png')

        return `
            <div id="place_${item.place_id}" class="mercenary-user-marker-container marker member">
                <div>
                    <img class="off ${item.place_id}" style="width: 65px" src=${mainImage}>
                    <img class="on ${item.place_id}" style="width: 65px; display: none;" src=${onMainImage}>
                </div>
            </div>
        `
    }

    _obj.soccerTeamMarker = function(item) {
        const imagePath = require('@/assets/img/logo_test.png')
        return `
            <div class="soccer_team_container">
                <img style="width: 100%; height: 100%;" src=${item.image_path ? Vue.prototype.$resourcePath + item.image_path : imagePath}>
            </div>
        `
    }

    _obj.trainingMarker = function(item) {
        let image
        if (item.slider_images.length > 0) {
            image = item.slider_images[0].image_path
        } else {
            image = item.place_images[0].thumb_image_path0
        }
        image

        return `
            <div style="">
                <svg width="40" height="45" viewBox="0 0 40 46" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                        <clipPath id="pin-shape">
                            <path d="M20 0C31.0457 0 40 8.9543 40 20C40 29.7813 32.9779 37.9206 23.7002 39.6562L20.8643 44.5195C20.4784 45.181 19.5216 45.181 19.1357 44.5195L16.2988 39.6562C7.02157 37.9202 0 29.781 0 20C0 8.9543 8.9543 0 20 0Z"/>
                        </clipPath>
                    </defs>

                    <image href="${Vue.prototype.$resourcePath + image}"
                        width="40"
                        height="46"
                        clip-path="url(#pin-shape)"
                        preserveAspectRatio="xMidYMid slice"
                    />

                    <path d="M20 0C31.0457 0 40 8.9543 40 20C40 29.7813 32.9779 37.9206 23.7002 39.6562L20.8643 44.5195C20.4784 45.181 19.5216 45.181 19.1357 44.5195L16.2988 39.6562C7.02157 37.9202 0 29.781 0 20C0 8.9543 8.9543 0 20 0Z"
                        fill="none"
                        stroke="white"
                        stroke-width="2"
                    />
                </svg>

            </div>
        `
    }

    return _obj;
})();
Util.Mercenary = Mercenary;
Util.Mercenary.Marker = MercenaryMarker;

export default Util
